import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationToolsService } from '../../../services/translationTools.service';

@Component({
  selector: 'app-translation-service-tools-editor',
  templateUrl: './translation-service-tools-editor.component.html',
  styleUrls: ['./translation-service-tools-editor.component.css']
})
export class TranslationServiceToolsEditorComponent implements OnInit {
  translationToolForm: FormGroup;
  isSaving = false;
  isEditMode = false;
  currentName: string = null;
  translationServices: any[] = [];
  displayedColumns: string[] = ['name', 'actions'];

  constructor(
    private fb: FormBuilder,
    private translationToolsService: TranslationToolsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.initForm();
    this.loadTranslationServices();
  }

  initForm() {
    this.translationToolForm = this.fb.group({
      translation_tool_name: ['', Validators.required]
    });
  }

  loadTranslationServices() {
    this.translationToolsService.getTranslationServices().subscribe(
      (data) => {
        console.log('Loaded translation services:', data); // Debugging log
        this.translationServices = data;
      },
      (error) => {
        this.snackBar.open('Error loading translation services', 'Close', {
          duration: 3000
        });
      }
    );
  }

  saveTranslationTool() {
    if (this.translationToolForm.invalid) {
      return;
    }

    this.isSaving = true;
    const name = this.translationToolForm.get('translation_tool_name').value;

    if (this.isEditMode) {
      this.updateTranslationTool(name);
    } else {
      this.createTranslationTool(name);
    }
  }

  createTranslationTool(name: string) {
    this.translationToolsService.createTranslation(name)
      .then(() => {
        this.snackBar.open('Translation Tool created successfully', 'Close', {
          duration: 3000
        });
        this.resetForm();
        this.loadTranslationServices();
      })
      .catch(error => {
        this.snackBar.open('Error creating Translation Tool', 'Close', {
          duration: 3000
        });
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  updateTranslationTool(newName: string) {
    if (!this.currentName) return;

    this.translationToolsService.updateTranslation(this.currentName, newName)
      .then(() => {
        this.snackBar.open('Translation Tool updated successfully', 'Close', {
          duration: 3000
        });
        this.resetForm();
        this.loadTranslationServices();
      })
      .catch(error => {
        this.snackBar.open('Error updating Translation Tool', 'Close', {
          duration: 3000
        });
      })
      .finally(() => {
        this.isSaving = false;
        this.isEditMode = false;
      });
  }

  deleteTranslationTool2() {
    if (!this.currentName) return;

    this.isSaving = true;
    this.translationToolsService.deleteTranslation(this.currentName)
      .then(() => {
        this.snackBar.open('Translation Tool deleted successfully', 'Close', {
          duration: 3000
        });
        
        this.loadTranslationServices();
      })
      .catch(error => {
        this.snackBar.open('Error deleting Translation Tool', 'Close', {
          duration: 3000
        });
      })
      .finally(() => {
        this.isSaving = false;
        this.isEditMode = false;
      });
  }

  deleteTranslationTool() {
    if (!this.currentName) return;
  
    this.isSaving = true;
    this.translationToolsService.deleteTranslation2(this.currentName).subscribe(
      () => {
        this.snackBar.open('Translation Tool deleted successfully', 'Close', {
          duration: 3000
        });
        this.loadTranslationServices();
      },
      (error) => {
        this.snackBar.open('Error deleting Translation Tool', 'Close', {
          duration: 3000
        });
      },
      () => {
        this.isSaving = false;
        this.isEditMode = false;
      }
    );
  }

  resetForm() {
    this.translationToolForm.reset();
    this.currentName = null;
    this.isEditMode = false;
  }

  setEditMode(name: string) {
    this.isEditMode = true;
    this.currentName = name;
    this.translationToolForm.patchValue({
      translation_tool_name: name
    });
  }
}
